export const WOUND_CONSTANTS = [
    {
        label: 'Client',
        name: 'clientId',
        type: 'searchableSelect',
        options: [],
        disabled: false,
        required: true,
        rowNumber: 1,
    },
    {
        label: 'Assessment Date',
        name: 'date',
        type: 'date',
        required: true,
        rowNumber: 1,
        maxDate: new Date(),
        minDate: new Date('1970-01-01')
    },
    {
        label: 'Start Time',
        name: 'startTime',
        type: 'string-time',
        required: true,
        rowNumber: 2,
    },
    {
        label: 'End Time',
        name: 'endTime',
        type: 'string-time',
        required: true,
        rowNumber: 2,
    },
    {
        sectionHeading: 'PLEASE SELECT WOUND TYPE (complete seperate sheet for each wound)',
        rowNumber: 4
    },
    {
        label: '',
        name: 'woundType',
        type: 'checkbox',
        options: [
            { label: 'Pressure Ulcer', value: 'Pressure Ulcer' },
            { label: 'Diabetic Foot Ulcer', value: 'Diabetic Foot Ulcer' },
            { label: 'Moisture Lesion', value: 'Moisture Lesion' },
            { label: 'Tramatic Wound', value: 'Tramatic Wound' },
            { label: 'Burn/Scald', value: 'Burn/Scald' },
            { label: 'Fungating Wound', value: 'Fungating Wound' },
            { label: 'Sinus/Fistula', value: 'Sinus/Fistula' },
            { label: 'Surgical Wound', value: 'Surgical Wound' },
            { label: 'Skin Tear/Laceration', value: 'Skin Tear/Laceration' },
            { label: 'Leg Ulcer', value: 'Leg Ulcer' },
        ],
        required: true,
        rowNumber: 5,
    },
    {
        label: 'Other Wound Type',
        name: 'otherWoundType',
        type: 'textarea',
        required: false,
        rowNumber: 6,
        minRows: 3,
    },
    {
        sectionHeading: 'WOUND DURATION',
        rowNumber: 7
    },
    {
        label: '',
        name: 'woundDuration',
        type: 'radio',
        options: [
            { label: 'Acute (<6 wks)', value: 'Acute (<6 wks)' },
            { label: 'Chronic (>6 wks)', value: 'Chronic (>6 wks)' },
        ],
        required: true,
        rowNumber: 7,
    },

    //PATIENT FACTORS THAT MAY AFFECT WOUND HEALING
    {
        sectionHeading: 'PATIENT FACTORS THAT MAY AFFECT WOUND HEALING',
        rowNumber: 8
    },
    {
        label: 'Such as diabetes, Infection, Nutritional status, Medication)',
        name: 'otherPatientFactors',
        type: 'textarea',
        required: false,
        rowNumber: 8,
        minRows: 3,
    },
    {
        name: 'patientFactors',
        type: 'checkbox',
        rowNumber: 9,
        required: false,
        options: [
            {
                label: 'Does client have Mental Capacity?',
                value: 'Does client have Mental Capacity?',
            },
            {
                label: 'Has client consented to treatment?',
                value: 'Has client consented to treatment?',
            },
            {
                label: 'Is care in the client\'s best interest?',
                value: 'Is care in the client\'s best interest?',
            },
        ],
    },
    {
        sectionHeading: 'PAIN ASSESSMENT',
        rowNumber: 10
    },
    {
        name: 'painAssessment',
        type: 'radio',
        rowNumber: 10,
        required: false,
        options: [
            {
                label: '0',
                value: '0',
            },
            {
                label: '1',
                value: '1',
            },
            {
                label: '2',
                value: '2',
            },
            {
                label: '3',
                value: '3',
            },
            {
                label: '4',
                value: '4',
            },
            {
                label: '5',
                value: '5',
            },
            {
                label: '6',
                value: '6',
            },
            {
                label: '7',
                value: '7',
            },
            {
                label: '8',
                value: '8',
            },
            {
                label: '9',
                value: '9',
            },
            {
                label: '10',
                value: '10',
            },
        ],
    },
    {
        sectionHeading: 'WHEN DOES PAIN OCCUR',
        rowNumber: 11
    },
    {
        name: 'whenDoesPainOccur',
        rowNumber: 11,
        required: false,
        type: 'checkbox',
        options: [
            { label: 'Dressing change', value: 'Dressing change' },
            { label: 'Movement', value: 'Movement' },
            { label: 'Continuous', value: 'Continuous' },
        ],
    },
    {
        label: 'Other',
        name: 'otherWhenDoesPainOccur',
        type: 'textarea',
        required: false,
        rowNumber: 12,
        minRows: 3,
    },
    {
        sectionHeading: 'PRESSURE RELIEVING EQUIPMENT IN USE?',
        rowNumber: 13
    },
    {
        label: 'Mattress',
        name: 'mattressInUse',
        type: 'select',
        rowNumber: 14,
        required: false,
        options: [
            {
                label: 'Yes',
                value: 'Yes',
            },
            {
                label: 'No',
                value: 'No',
            },
        ],
    },
    {
        label: 'Date Ordered/Initiated',
        name: 'mattressDateOrdered',
        type: 'date',
        required: false,
        rowNumber: 14,
        maxDate: new Date(),
        minDate: new Date('1970-01-01')
    },
    {
        label: 'Cushion',
        name: 'cushionInUse',
        type: 'select',
        rowNumber: 15,
        required: false,
        options: [
            { label: 'Yes', value: 'Yes' },
            { label: 'No', value: 'No' },
        ],
    },
    {
        label: 'Date Ordered/Initiated',
        name: 'cushionDateOrdered',
        type: 'date',
        required: false,
        rowNumber: 15,
        maxDate: new Date(),
        minDate: new Date('1970-01-01')
    },
    {
        label: 'Heel Protection:',
        name: 'heelProtection',
        type: 'select',
        rowNumber: 16,
        required: false,
        options: [
            { label: 'Yes', value: 'Yes' },
            { label: 'No', value: 'No' },
        ],
    },
    {
        label: 'Date Ordered/Initiated',
        name: 'heelProtectionDateOrdered',
        type: 'date',
        required: false,
        rowNumber: 16,
        maxDate: new Date(),
        minDate: new Date('1970-01-01')
    },
    {
        label: 'Other',
        name: 'otherPressureRelievingEquipmentInUse',
        type: 'select',
        rowNumber: 17,
        required: false,
        options: [
            { label: 'Yes', value: 'Yes' },
            { label: 'No', value: 'No' },
        ],
    },
    {
        label: 'Date Ordered/Initiated',
        name: 'otherDateOrdered',
        type: 'date',
        required: false,
        rowNumber: 17,
        maxDate: new Date(),
        minDate: new Date('1970-01-01')
    },
    {
        sectionHeading: 'INITIAL ASSESSMENT:',
        rowNumber: 18
    },
    {
        sectionHeading: 'Wound bed condition (100%)',
        rowNumber: 19
    },
    {
        name: 'woundBedCondition',
        rowNumber: 19,
        required: false,
        type: 'checkbox',
        options: [
            { label: 'Epithelising', value: 'Epithelising' },
            { label: 'Healthy Granulation', value: 'Healthy Granulation' },
            { label: 'Slough (yellow/brown)', value: 'Slough (yellow/brown)' },
            { label: 'Necrotic (black/brown)', value: 'Necrotic (black/brown)' },
            { label: 'Over Granulation', value: 'Over Granulation' },
            { label: 'Mixed Tissue', value: 'Mixed Tissue' },
            { label: 'Fungating/Malignant', value: 'Fungating/Malignant' },
            { label: 'Bone/Tendon/Ligament', value: 'Bone/Tendon/Ligament' },
            { label: 'Cellulitic', value: 'Cellulitic' },
            { label: 'Infected/critically colonised', value: 'Infected/critically colonised' },
        ],
    },
    {
        sectionHeading: 'WOUND SIZE (cm)',
        rowNumber: 20
    },
    {
        label: 'Length',
        name: 'woundLength',
        type: 'number',
        required: false,
        rowNumber: 21,
    },
    {
        label: 'Width',
        name: 'woundWidth',
        type: 'number',
        required: false,
        rowNumber: 21,
    },
    {
        label: 'Depth',
        name: 'woundDepth',
        type: 'number',
        required: false,
        rowNumber: 21,
    },
    {
        label: 'Undermining/Tunneling',
        name: 'woundUndermining',
        type: 'text',
        required: false,
        rowNumber: 22,
    },
    {
        label: 'Tracking',
        name: 'woundTracking',
        type: 'text',
        required: false,
        rowNumber: 22,
    },
    {
        sectionHeading: 'EUPAP CLASSIFICATION',
        rowNumber: 23
    },
    {
        sectionHeading: 'Pressure ulcer grade/stage',
        rowNumber: 24
    },
    {
        name: 'eupapClassification',
        type: 'radio',
        rowNumber: 24,
        required: false,
        options: [
            {
                label: '1',
                value: '1',
            },
            {
                label: '2',
                value: '2',
            },
            {
                label: '3',
                value: '3',
            },
            {
                label: '4',
                value: '4',
            },

        ],
    },
    {
        sectionHeading: 'ABPI (Leg Ulcer)',
        rowNumber: 25
    },
    {
        label: 'Date',
        name: 'abpiDate',
        type: 'date',
        required: false,
        rowNumber: 26,
        maxDate: new Date(),
        minDate: new Date('1970-01-01')
    },
    {
        label: 'Leg',
        name: 'abpiLeg',
        type: 'multiSelect',
        options: [
            { label: 'Left', value: 'Left' },
            { label: 'Right', value: 'Right' },
        ],
        required: false,
        rowNumber: 26,
    },
    {
        sectionHeading: 'CONDITION OF SURROUNDING SKIN',
        rowNumber: 27
    },
    {
        name: 'conditionOfSurroundingSkin',
        rowNumber: 27,
        required: false,
        type: 'checkbox',
        options: [
            { label: 'Healthy/Intact', value: 'Healthy/Intact' },
            { label: 'Dry/cracked', value: 'Dry/cracked' },
            { label: 'Discoloured', value: 'Discoloured' },
            { label: 'Fragile', value: 'Fragile' },
            { label: 'Macerated', value: 'Macerated' },
            { label: 'Eczematous', value: 'Eczematous' },
            { label: 'Odematous', value: 'Odematous' },
            { label: 'Excoriated', value: 'Excoriated' },
        ],
    },
    {
        sectionHeading: 'FURTHER BASELING ASSESSMENT',
        rowNumber: 27
    },
    {
        sectionHeading: 'Wound Mapped',
        rowNumber: 28
    },
    {
        name: 'woundMapped',
        type: 'radio',
        rowNumber: 29,
        required: false,
        options: [
            { label: 'Yes', value: 'Yes' },
            { label: 'No', value: 'No' },
        ],
    },
    {
        sectionHeading: 'INFECTION SUSPECTED',
        rowNumber: 30
    },
    {
        label: 'Wound Swab?',
        name: 'woundSwab',
        type: 'select',
        options: [
            { label: 'Yes', value: 'Yes' },
            { label: 'No', value: 'No' },
        ],
        required: false,
        rowNumber: 31,
    },
    {
        label: 'Date Taken',
        name: 'dateTaken',
        type: 'date',
        required: false,
        rowNumber: 31,
        maxDate: new Date(),
        minDate: new Date('1970-01-01')
    },
    {
        label: 'Result',
        name: 'result',
        type: 'text',
        required: false,
        rowNumber: 31,
    },
    {
        label: 'Antibiotic Therapy',
        name: 'antibioticTherapy',
        type: 'text',
        required: false,
        rowNumber: 32,
    },
    {
        label: 'Antimicrobial',
        name: 'antimicrobial',
        type: 'text',
        required: false,
        rowNumber: 32,
    },
    {
        sectionHeading: 'INITIAL WOUND MANAGEMENT PLAN',
        rowNumber: 33
    },
    {
        sectionHeading: 'Wound Management Aims',
        rowNumber: 34
    },
    {
        name: 'woundManagementPlan',
        rowNumber: 35,
        required: false,
        type: 'checkbox',
        options: [
            { label: 'Debride', value: 'Debride' },
            { label: 'Deslough', value: 'Deslough' },
            { label: 'Protect', value: 'Protect' },
            { label: 'Hydrate', value: 'Hydrate' },
            { label: 'Reduce Bacterial Load', value: 'Reduce Bacterial Load' },
            { label: 'Reduce Odor', value: 'Reduce Odor' },
            { label: 'Keep Dry', value: 'Keep Dry' },
            { label: 'Encourage Granulation', value: 'Encourage Granulation' },
        ],
    },
    {
        label: 'Debridement Method',
        name: 'debridementMethod',
        type: 'textarea',
        required: false,
        rowNumber: 37,
        minRows: 3,
    },
    {
        label: 'Cleansing Solution',
        name: 'cleansingSolution',
        type: 'textarea',
        required: false,
        rowNumber: 38,
        minRows: 3,
    },
    {
        label: 'Barrier preparation/adhesive remover',
        name: 'barrierPreparation',
        type: 'textarea',
        required: false,
        rowNumber: 39,
        minRows: 3,
    },
    {
        label: 'Other Instructions',
        name: 'otherInstructions',
        type: 'textarea',
        required: false,
        rowNumber: 40,
        minRows: 3,
    },
    {
        label: 'Primary Dressing',
        name: 'primaryDressing',
        type: 'textarea',
        required: false,
        rowNumber: 41,
        minRows: 3,
    },
    {
        label: 'Secondary  Dressing',
        name: 'secondaryDressing',
        type: 'textarea',
        required: false,
        rowNumber: 42,
        minRows: 3,
    },
    {
        label: 'Fixation method/Bandaging',
        name: 'bandaging',
        type: 'textarea',
        required: false,
        rowNumber: 43,
        minRows: 3,
    },
    {
        label: 'Frequency of Dressing Change',
        name: 'frequencyOfDressingChange',
        type: 'textarea',
        required: false,
        rowNumber: 44,
        minRows: 3,
    },
    {
        label: 'Reassessment Frequency',
        name: 'reassessmentFrequency',
        type: 'select',
        options: [
            { label: 'Daily', value: 'Daily' },
            { label: 'Weekly', value: 'Weekly' },
            { label: 'Monthly', value: 'Monthly' },
        ],
        required: false,
        rowNumber: 45,
    },
    {
        label: 'Next Reassessment Date',
        name: 'nextReassessmentDate',
        type: 'date',
        required: false,
        rowNumber: 45,
        maxDate: new Date('2070-01-01'),
        minDate: new Date()
    },
    {
        sectionHeading: 'Referral Required?',
        rowNumber: 46
    },
    {
        name: 'referralRequirreed',
        rowNumber: 47,
        required: false,
        type: 'checkbox',
        options: [
            { label: 'Tissue Viability Nurse', value: 'Tissue Viability Nurse' },
            { label: 'Podiatrist', value: 'Podiatrist' },
            { label: 'Plastic Surgeon', value: 'Plastic Surgeon' },
            { label: 'Vascular Surgeon', value: 'Vascular Surgeon' },
            { label: 'Dietitian', value: 'Dietitian' },
            { label: 'Wound Care Physician', value: 'Wound Care Physician' },
            { label: 'Other', value: 'Other' },
        ],
    },
    {
        label: 'Reason for referral',
        name: 'reasonForReferral',
        type: 'textarea',
        required: false,
        rowNumber: 48,
        minRows: 3,
    },
]
export const WOUND_ENTRIES_CONSTANTS = [
    {
        label: 'Client',
        name: 'clientId',
        type: 'searchableSelect',
        options: [],
        disabled: false,
        required: true,
        rowNumber: 1,
    },
    {
        label: 'Type',
        name: 'woundType',
        type: 'select',
        rowNumber: 1,
        required: false,
        options: [
            { label: 'Diabetic Ulcer', value: 'Diabetic Ulcer' },
            { label: 'Presure Ulcer', value: 'Presure Ulcer' },
            { label: 'Venous Stasis Ulcer', value: 'Venous Stasis Ulcer' },
            { label: 'Arterial Ulcer', value: 'Arterial Ulcer' },
            { label: 'Traumatic Wound', value: 'Traumatic Wound' },
            { label: 'Burn/Scald', value: 'Burn/Scald' },
            { label: 'Surgical Wound', value: 'Surgical Wound' },
            { label: 'Other', value: 'Other' },
        ],
    },
    {
        label: 'Assessment Date',
        name: 'date',
        type: 'date',
        required: true,
        rowNumber: 1,
        maxDate: new Date(),
        minDate: new Date('1970-01-01')
    },
    {
        label: 'Start Time',
        name: 'startTime',
        type: 'string-time',
        required: true,
        rowNumber: 2,
    },
    {
        label: 'End Time',
        name: 'endTime',
        type: 'string-time',
        required: true,
        rowNumber: 2,
    },
    {
        sectionHeading: 'WOUND SIZE (cm)',
        rowNumber: 3
    },
    {
        label: 'Length',
        name: 'woundLength',
        type: 'number',
        required: false,
        rowNumber: 4,
    },
    {
        label: 'Width',
        name: 'woundWidth',
        type: 'number',
        required: false,
        rowNumber: 4,
    },
    {
        label: 'Depth',
        name: 'woundDepth',
        type: 'number',
        required: false,
        rowNumber: 4,
    },
    {
        sectionHeading: 'ADDRESS INFORMATION',
        rowNumber: 5,
    },
    {
        addressInfo: true,
        rowNumber: 5,
    },
    {
        label: 'Other Wound Type',
        name: 'otherWoundType',
        type: 'textarea',
        required: false,
        rowNumber: 6,
        minRows: 3,
    },
    {
        label: 'Stage',
        name: 'woundStage',
        type: 'select',
        rowNumber: 7,
        required: false,
        options: [
            { label: 'Stage 1', value: 'Stage 1' },
            { label: 'Stage 2', value: 'Stage 2' },
            { label: 'Stage 3', value: 'Stage 3' },
            { label: 'Stage 4', value: 'Stage 4' },
            { label: 'Non Obserevable', value: 'Non Obserevable' },
        ],
    },
    {
        label: 'Unstageable',
        name: 'unStageable',
        type: 'select',
        rowNumber: 7,
        required: false,
        options: [
            { label: 'Non Removable Dressing', value: 'Non Removable Dressing' },
            { label: 'Slough', value: 'Slough' },
            { label: 'Eschar', value: 'Eschar' },
            { label: 'Deep Tissue Injury', value: 'Deep Tissue Injury' },
        ],
    },
    {
        label: 'Wound Bed',
        name: 'woundBed',
        type: 'text',
        rowNumber: 8,
        required: false,
    },    
    {
        sectionHeading: 'Drainage',
        rowNumber: 9
    },
    {
        name: 'drainage',
        type: 'radio',
        rowNumber: 10,
        required: false,
        options: [
            {
                label: 'None',
                value: 'None',
            },
            {
                label: 'Small',
                value: 'Small',
            },
            {
                label: 'Moderate',
                value: 'Moderate',
            },
            {
                label: 'Large',
                value: 'Large',
            },
        ],
    },
    {
        label: 'Color',
        name: 'color',
        type: 'select',
        required: false,
        rowNumber: 11,
        options: [
            { label: 'Clear', value: 'Clear' },
            { label: 'Serosanguineous', value: 'Serosanguineous' },
            { label: 'Bloody', value: 'Bloody' },
            { label: 'Yellow', value: 'Yellow' },
            { label: 'Green', value: 'Green' },
            { label: 'Brown', value: 'Brown' },
            { label: 'White', value: 'White' },
        ],
    },
    {
        label: 'Other Color',
        name: 'otherColor',
        type: 'text',
        required: false,
        rowNumber: 11,
    },
    {
        label: 'Odor',
        name: 'odor',
        type: 'text',
        rowNumber: 12,
        required: false,
    },
    {
        label: 'Undermining/Tunneling',
        name: 'woundUndermining',
        type: 'text',
        required: false,
        rowNumber: 12,
    },
    {
        label: 'Surrounding Tissue',
        name: 'surroundingTissue',
        type: 'text',
        required: false,
        rowNumber: 13,
    },
    {
        label: 'Edema',
        name: 'edema',
        type: 'text',
        required: false,
        rowNumber: 13,
    },
    {
        label: 'Stoma',
        name: 'stoma',
        type: 'text',
        required: false,
        rowNumber: 14,
    },
    {
        label: 'Wound Status',
        name: 'woundStatus',
        type: 'select',
        options: [
            { label: 'Fully Granulating', value: 'Fully Granulating' },
            { label: 'Early/Partially Granulating', value: 'Early/Partially Granulating' },
            { label: 'None Healing', value: 'None Healing' },
        ],
        required: false,
        rowNumber: 14,
    },
    {
        label: 'Wound Care',
        name: 'woundCare',
        type: 'textarea',
        required: false,
        rowNumber: 15,
        minRows: 3,
    },
    {
        sectionHeading: 'Satisfactory Return Demo',
        rowNumber: 16
    },
    {
        name: 'satisfactoryReturnDemo',
        type: 'radio',
        rowNumber: 16,
        required: false,
        options: [
            { label: 'Yes', value: 'Yes' },
            { label: 'No', value: 'No' },
        ],
    },
    {
        sectionHeading: 'Patient Response',
        rowNumber: 17
    },
    {
        name: 'patientResponse',
        type: 'radio',
        rowNumber: 17,
        required: false,
        options: [
            { label: 'Poor', value: 'Poor' },
            { label: 'Fair', value: 'Fair' },
            { label: 'Good', value: 'Good' },
        ],
    }
]